export default __webpack_public_path__ + "static/media/tameImpala.f699d689.jpeg";